import React from 'react';
import { CheckCircleIcon } from 'lucide-react';
import { faqItems } from '../data/faq';
export function FAQSection() {
  return <section className="w-full bg-gray-100 px-6 py-20 sm:px-10" data-id="element-54" data-mp="1wx13978jfe3x">
      <div className="mx-auto max-w-3xl" data-id="element-55" data-mp="1iw88qmi8kj0t">
        <h2 className="text-center font-heading text-3xl font-bold text-mint-dark sm:text-4xl" data-id="element-56" data-mp="1ixj90cch38n6">Preguntas frecuentes</h2>

        <div className="mt-12 space-y-4" data-id="element-57" data-mp="1nwme1wsgdev5">
          {faqItems.map(item => <div key={item.pregunta} className="rounded-xl border border-gray-200 bg-white p-6" data-id="element-58" data-mp="2bl5ks7vutjl4">
              <p className="flex items-start gap-2 text-base font-bold text-mint-dark" data-id="element-59" data-mp="2fl5yfqb4pqr4">
                <CheckCircleIcon className="mt-0.5 h-5 w-5 shrink-0 text-success" aria-hidden="true" data-id="element-60" data-mp="21u16lae062rc" />
                {item.pregunta}
              </p>
              <p className="mt-3 pl-7 text-sm leading-loose text-gray-600" data-id="element-61" data-mp="2ujhubuqogvh8">
                <span className="font-bold text-mint-dark" data-id="element-62" data-mp="2uhdimqmjes6e">{item.resumen}</span> {item.respuesta}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}